module.exports = __webpack_public_path__ + "static/media/mon-sun_and_everyday_digital.31553356.png";